import { http } from './http';
import type { OperationResult, Schemas } from './shared';

/**
 * Current-user / session probe. Owned by the api layer rather than a feature
 * folder because it's the authentication boundary (called by `useMe` and the
 * session guard); no domain feature exclusively owns it.
 */

export type CurrentUserDto = Schemas['CurrentUser'];
export type PermissionDto = Schemas['Permission'];

export const meApi = {
  /** GET /me — current user identity + permissions. */
  getCurrentUser: (options?: { signal?: AbortSignal }): Promise<OperationResult<'getCurrentUser'>> =>
    http.get<OperationResult<'getCurrentUser'>>('/me', options),
};
